import { render, staticRenderFns } from "./GoodManageDetail.vue?vue&type=template&id=18765eda&scoped=true"
import script from "./GoodManageDetail.vue?vue&type=script&lang=js"
export * from "./GoodManageDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodManageDetail.vue?vue&type=style&index=0&id=18765eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18765eda",
  null
  
)

export default component.exports